const GENERIC = 'Tester.jpg';

export function userAvatarUrl(image, cacheKey, fallback = false) {
  const file = String(image ?? '').trim();
  const name = file || (fallback ? GENERIC : '');
  if (!name) return '';
  const root = process.env.VUE_APP_USER_IMG_ROOT || '';
  const cache = cacheKey != null && cacheKey !== '' ? `?cache=${cacheKey}` : '';
  return `${root}${name}${cache}`;
}
